let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("52kH5")).then(() => parcelRequire('hDYsT'));